import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Button } from '@vk-hr-tek/ui/Button';
import { Icon } from '@vk-hr-tek/ui/Icon';
import { Typography } from '@vk-hr-tek/ui/Typography';

const FADED_OPACITY_VALUE = 0.5;

export const AnswerDnDFallback = () => {
  return (
    <Box
      p="24"
      radius="l"
      border={1}
      bgcolor="bg.light.primary"
      borderColor="stroke.primary"
      opacity={FADED_OPACITY_VALUE}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle2">Вариант ответа</Typography>

        <Button
          variant="tertiaryLight"
          icon={
            <Icon name="dots_vertical" color="text.light.secondary" size="24" />
          }
        />
      </Box>
    </Box>
  );
};
